/* OKKO B2B — wishlist PER-DISPOSITIVO (localStorage).
 *
 * Scelta esplicita di Nicolas: niente sync sull'account per ora — un tema non ha
 * una via di scrittura verso il customer (Storefront read-only, token Admin non
 * puo' stare nel browser); il sync richiederebbe un'app o un mini-backend con
 * App Proxy (e' cosi' che fa anche iWishlist su puro.it). La struttura dati e'
 * la STESSA della bozza: se un domani si aggiunge il backend, la UI resta.
 *
 * localStorage (non sessionStorage): sopravvive alla chiusura del browser.
 */

(() => {
  'use strict';

  const KEY = 'okko-wishlist';

  const load = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; }
    catch { return {}; }
  };

  const save = (w) => {
    try {
      if (Object.keys(w).length) localStorage.setItem(KEY, JSON.stringify(w));
      else localStorage.removeItem(KEY);
    } catch { /* storage negato: la wishlist degrada a stato di pagina */ }
  };

  const money = (cents) => (window.OKKO && window.OKKO.money
    ? window.OKKO.money(cents)
    : `\u20ac${(cents / 100).toFixed(2)}`);

  const esc = (str) => String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');

  /**
   * Ordine scelto dall'utente. Serve un campo esplicito: le chiavi di questa
   * mappa sono id variante, cioe' stringhe "intere", e JS le enumera SEMPRE in
   * ordine numerico crescente — l'ordine di inserimento non sopravvive.
   * Le voci salvate prima (senza `o`) finiscono in coda, stabili tra loro.
   */
  const ordinate = (w) => Object.entries(w)
    .sort((a, b) => (a[1].o ?? Infinity) - (b[1].o ?? Infinity));

  const prossimoOrdine = (w) => {
    const valori = Object.values(w).map((e) => e.o).filter((n) => typeof n === 'number');
    return valori.length ? Math.max(...valori) + 1 : 0;
  };

  /** Riscrive il campo `o` seguendo l'ordine delle righe nel DOM. */
  function salvaOrdineDalDom() {
    const w = load();
    [...dialog.querySelectorAll('[data-okko-wl-row]')].forEach((riga, i) => {
      const en = w[riga.dataset.okkoWlRow];
      if (en) en.o = i;
    });
    save(w);
  }

  // puntini a r 1.5 (erano 1.3): registro BOLD del set icone (2026-08-03)
  const DRAG_SVG = '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><circle cx="5.8" cy="3.5" r="1.5"/><circle cx="10.2" cy="3.5" r="1.5"/><circle cx="5.8" cy="8" r="1.5"/><circle cx="10.2" cy="8" r="1.5"/><circle cx="5.8" cy="12.5" r="1.5"/><circle cx="10.2" cy="12.5" r="1.5"/></svg>';

  const HEART = '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M8 14 2.8 8.9a3.5 3.5 0 0 1 0-5 3.4 3.4 0 0 1 4.9 0l.3.4.3-.4a3.4 3.4 0 0 1 4.9 0 3.5 3.5 0 0 1 0 5Z"/></svg>';

  const CHEVRON_SVG = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 6l4.5 4.5L12.5 6"/></svg>';

  // --- Stato sui cuori e badge in topbar -------------------------------------

  /**
   * Tooltip del segnalibro: solo quando il click SALVA. A prodotto gia' salvato
   * il gesto e' "togli" ed e' evidente dall'icona piena, quindi niente tooltip.
   */
  function tipSegnalibro(btn, salvato) {
    const T = (window.OKKO && window.OKKO.testi) || {};
    if (salvato) delete btn.dataset.okkoTip;
    else btn.dataset.okkoTip = T.salvaProdotto || 'Salva il prodotto';
  }

  function paint() {
    const w = load();
    // Segnalibri nel Riepilogo bozza (righe JS, niente data-okko-line)
    document.querySelectorAll('[data-okko-wl-toggle]').forEach((btn) => {
      const salvato = Boolean(w[btn.dataset.okkoWlToggle]);
      btn.classList.toggle('is-on', salvato);
      tipSegnalibro(btn, salvato);
    });
    // Segnalibro della PDP mono-variante (bottone standalone, niente riga)
    document.querySelectorAll('[data-okko-pdp-wish]').forEach((btn) => {
      const salvato = Boolean(w[btn.dataset.variantId]);
      btn.classList.toggle('is-on', salvato);
      tipSegnalibro(btn, salvato);
    });
    // Segnalibro di PRODOTTO sulle righe genitore del catalogo (chiave = product id)
    document.querySelectorAll('[data-okko-wish-parent]').forEach((btn) => {
      const salvato = Boolean(w[btn.dataset.productId]);
      btn.classList.toggle('is-on', salvato);
      tipSegnalibro(btn, salvato);
    });
    let dirty = false;
    document.querySelectorAll('[data-okko-line]').forEach((tr) => {
      const btn = tr.querySelector('[data-okko-wish]');
      if (btn) {
        const salvato = Boolean(w[tr.dataset.variantId]);
        btn.classList.toggle('is-on', salvato);
        tipSegnalibro(btn, salvato);
      }
      // il DOM e' piu' fresco dello storage: riallinea titolo/prezzo/stock delle entry visibili.
      // MA solo quando il ponte BSS ha gia' applicato lo sconto (o non c'e'): al load le
      // righe partono a prezzo PIENO e il ponte le sconta async; senza questa guardia il
      // refresh cattura il pieno e sovrascrive l'entry gia' scontata (clobber). paint()
      // ri-gira su okko:bss:pronto per riallineare col prezzo scontato definitivo.
      const bss = window.OKKO && window.OKKO.bss;
      const prezziPronti = !bss || bss.pronto;
      const en = w[tr.dataset.variantId];
      if (prezziPronti && en && window.OKKO && window.OKKO.lineEntry) {
        const fresh = window.OKKO.lineEntry(tr);
        if (fresh.t !== en.t || fresh.p !== en.p || fresh.m !== en.m || fresh.cf !== (en.cf || 0)) {
          w[tr.dataset.variantId] = { ...en, ...fresh, q: en.q || 1 };
          dirty = true;
        }
      }
      // sotto-riga di un GRUPPO salvato: riallinea la variante embedded in `vs`
      const gruppo = w[tr.dataset.okkoChildOf];
      if (prezziPronti && gruppo && gruppo.g && gruppo.vs && window.OKKO && window.OKKO.lineEntry) {
        const idx = gruppo.vs.findIndex((x) => String(x.id) === String(tr.dataset.variantId));
        if (idx !== -1) {
          const v = gruppo.vs[idx];
          const fresh = window.OKKO.lineEntry(tr);
          if (fresh.p !== v.p || fresh.m !== v.m || fresh.cf !== (v.cf || 0)) {
            gruppo.vs[idx] = { ...v, ...fresh };
            dirty = true;
          }
        }
      }
    });
    if (dirty) save(w);
    const count = Object.keys(w).length;
    // querySelectorAll: il badge ora vive anche nella sidebar della shell, non solo in topbar
    document.querySelectorAll('[data-okko-wishlist-count]').forEach((badge) => {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });
  }

  // Toggle dal Riepilogo bozza: l'entry arriva dalla bozza stessa (stessa forma)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-okko-wl-toggle]');
    if (!btn) return;
    const id = btn.dataset.okkoWlToggle;
    const w = load();
    if (w[id]) {
      delete w[id];
    } else {
      const entry = window.OKKO.draftEntry ? window.OKKO.draftEntry(id) : null;
      if (!entry) return;
      w[id] = { ...entry, q: 1, o: prossimoOrdine(w) };
    }
    save(w);
    paint();
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-okko-wish]');
    if (!btn) return;
    const tr = btn.closest('[data-okko-line]');
    const id = tr.dataset.variantId;
    const w = load();
    if (w[id]) {
      delete w[id];
    } else {
      const entry = window.OKKO.lineEntry(tr);
      w[id] = { ...entry, q: 1, o: prossimoOrdine(w) };
    }
    save(w);
    paint();
  });

  // Segnalibro di PRODOTTO sulla riga genitore del catalogo: entry `g` (gruppo)
  // con chiave = product id e le VARIANTI embedded in `vs`, lette al volo dalle
  // sotto-righe server-rendered (hanno gia' prezzo/stock/confezione/SKU). La
  // modale le rende richiudibili sotto il genitore, come in catalogo.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-okko-wish-parent]');
    if (!btn) return;
    e.stopPropagation(); // la riga genitore e' cliccabile (espande): il segnalibro non deve aprirla
    const pid = btn.dataset.productId;
    const w = load();
    if (w[pid]) {
      delete w[pid];
    } else {
      // In catalogo titolo/immagine si risalgono dalla cella; sulla PDP il
      // bottone e' standalone (blocks/lista-varianti) e li porta nei
      // data-attribute, che hanno la precedenza.
      const cell = btn.closest('.okko-cell-product');
      const a = cell && cell.querySelector('.okko-cell-titolo a');
      const img = cell && cell.querySelector('img');
      const vs = [...document.querySelectorAll(`[data-okko-child-of="${pid}"]`)]
        .map((riga) => window.OKKO.lineEntry(riga));
      if (!vs.length) return;
      w[pid] = {
        g: 1,
        pid: Number(pid),
        t: btn.dataset.title || (a ? a.textContent.trim() : ''),
        u: btn.dataset.url || (a ? a.getAttribute('href') || '' : ''),
        i: btn.dataset.img || (img ? (img.currentSrc || img.src) : ''),
        vs,
        o: prossimoOrdine(w),
      };
    }
    save(w);
    paint();
  }, true); // cattura: lo stopPropagation deve battere il toggle di riga in okko-cart.js

  // Segnalibro della PDP mono-variante ([data-okko-pdp-wish], blocks/acquisto):
  // la PDP non ha una riga [data-okko-line] (restoreDraft toglierebbe la variante
  // dalla bozza non trovando l'input di catalogo), quindi l'entry arriva dai
  // data-attribute del bottone. Prezzo pieno da Liquid: lo sconto BSS lo risolve
  // la modale Salvati da sola, via pid (stesso giro delle righe di catalogo).
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-okko-pdp-wish]');
    if (!btn) return;
    const id = btn.dataset.variantId;
    const w = load();
    if (w[id]) {
      delete w[id];
    } else {
      const d = btn.dataset;
      w[id] = {
        id: Number(id),
        pid: Number(d.productId) || null,
        p: Number(d.price),
        c: d.compare ? Number(d.compare) : null,
        op: null,
        m: d.max === undefined ? null : Number(d.max),
        cf: Number(d.conf) || 0,
        pre: d.pre || 0,
        t: d.title || '', v: '', s: d.sku || '', i: d.img || '', u: d.url || '',
        q: 1,
        o: prossimoOrdine(w),
      };
    }
    save(w);
    paint();
  });

  // --- Modale ----------------------------------------------------------------

  let dialog = null;

  function ensureDialog() {
    if (dialog) return dialog;
    // guscio server-rendered dal gruppo Strumenti (okko-strumento-salvati), se c'e'
    dialog = document.querySelector('[data-okko-salvati-modal]');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'okko-draft-modal';
      document.body.appendChild(dialog);
    }
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog || e.target.closest('[data-okko-wl-close]')) dialog.close();
    });
    return dialog;
  }

  // Sconto BSS risolto DALLA WISHLIST STESSA, all'apertura: NON dipende dal fatto che
  // il prodotto sia in una pagina caricata. Per ogni entry usa il pid (salvato dalla
  // riga; per le entry vecchie lo recupera da /products/<handle>.js) e il percorso LIVE
  // del ponte (assicuraProdotto -> prezzoVariante: dati freschi, non la cache del
  // download). Copre anche le regole per-collezione. Ritorna true se qualcosa e' cambiato.
  async function scontaSalvati(w) {
    const bss = window.OKKO && window.OKKO.bss;
    if (!bss) return false;
    try { await bss.attendiRegole(); } catch (e) { return false; }
    let changed = false;
    await Promise.all(Object.keys(w).map(async (vid) => {
      const en = w[vid];
      if (!en) return;
      // Gruppo: un giro di sconto per OGNI variante embedded, stesso criterio
      // delle voci singole (base = prezzo pieno, op = barrato solo se scontata).
      if (en.g) {
        if (!en.pid) return;
        await bss.assicuraProdotto(en.pid);
        (en.vs || []).forEach((v) => {
          const base = v.op || v.p;
          const pv = bss.prezzoVariante(v.id);
          const nuovoP = (pv && pv.p < base) ? pv.p : base;
          const nuovoOp = (pv && pv.p < base) ? base : null;
          if (v.p !== nuovoP || (v.op || null) !== nuovoOp) {
            v.p = nuovoP;
            if (nuovoOp) v.op = nuovoOp; else delete v.op;
            changed = true;
          }
        });
        return;
      }
      let pid = en.pid;
      if (!pid && en.u) { // entry vecchia senza pid: recuperalo dall'handle prodotto
        const handle = String(en.u).split('/products/')[1];
        if (handle) {
          try { const p = await fetch(`/products/${handle.split('?')[0]}.js`).then((r) => r.json()); pid = p && p.id; } catch (e) { /* noop */ }
        }
        if (pid) { en.pid = pid; changed = true; }
      }
      if (!pid) return;
      await bss.assicuraProdotto(pid);
      const base = en.op || en.p;                 // prezzo pieno di riferimento
      const v = bss.prezzoVariante(vid);
      const nuovoP = (v && v.p < base) ? v.p : base;
      const nuovoOp = (v && v.p < base) ? base : null;
      if (en.p !== nuovoP || (en.op || null) !== nuovoOp) {
        en.p = nuovoP;
        if (nuovoOp) en.op = nuovoOp; else delete en.op;
        changed = true;
      }
    }));
    return changed;
  }

  function render() {
    const w = load();
    const entries = ordinate(w);
    // voci salvate prima di data-compare: recupera il listino e ridisegna
    window.OKKO.completaListini(w).then((cambiato) => {
      if (!cambiato) return;
      save(w);
      render();
    });
    // sconto BSS risolto da sé (indipendente dalle pagine visitate): aggiorna e ridisegna
    scontaSalvati(w).then((cambiato) => { if (cambiato) { save(w); render(); } });
    const d = ensureDialog();
    if (!entries.length) {
      // editor del tema: la modale resta visibile con lo stato vuoto (anteprima)
      if (window.Shopify && window.Shopify.designMode) {
        d.innerHTML = `
          <div class="okko-draft-modal__head">
            <h2 class="okko-draft-modal__title">${(window.OKKO.testi || {}).salvati || 'Salvati'}</h2>
            <button type="button" class="okko-draft-modal__close" data-okko-wl-close aria-label="Chiudi"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M4.5 4.5l7 7M11.5 4.5l-7 7"/></svg></button>
          </div>
          <div class="okko-draft-modal__body"><p class="okko-ordini__vuoto">${(window.OKKO.testi || {}).nessunSalvato || 'Nessun prodotto salvato.'}</p></div>`;
        paint();
        return;
      }
      d.close(); paint(); return;
    }
    const ui = window.OKKO.ui;
    // quantita' gia' in bozza: lo stepper dei Salvati e' una VISTA sulla bozza
    const draftQty = (id) => (window.OKKO.draftEntry ? (window.OKKO.draftEntry(id)?.q || 0) : 0);

    const rows = entries.map(([id, en]) => {
      // cestino a destra, come nelle altre modali (Riepilogo/Ordine Rapido)
      const T = (window.OKKO && window.OKKO.testi) || {};
      const rimuovi = `<button type="button" class="okko-draft-row__remove" data-okko-wl-remove="${id}" aria-label="${T.rimuoviSalvati || 'Rimuovi dai salvati'}">${ui.TRASH_SVG}</button>`;
      const frecce = `<span class="okko-drag" data-okko-wl-drag data-okko-tip="${T.trascinaRiordina || 'Trascina per riordinare'}" title="${T.trascinaRiordina || 'Trascina per riordinare'}">${DRAG_SVG}</span>`
        + `<button type="button" class="okko-wl-freccia" data-okko-wl-sposta="-1" aria-label="Sposta su"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 10L8 5.5 12.5 10"/></svg></button>`
        + `<button type="button" class="okko-wl-freccia" data-okko-wl-sposta="1" aria-label="Sposta giu'"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 6L8 10.5 12.5 6"/></svg></button>`;

      // Entry di GRUPPO (prodotto genitore salvato dal catalogo): riga prodotto
      // con la pillola "N colori" + varianti richiudibili sotto, ognuna col suo
      // stepper che scrive nella bozza (stesso contratto delle righe singole).
      if (en.g) {
        const vs = en.vs || [];
        const kids = vs.map((v) => {
          const inBozza = draftQty(v.id);
          return ui.modalRow({
            img: v.i || en.i,
            title: v.v || v.t || 'Variante',
            sku: v.s,
            stock: v.m,
            pre: v.pre || 0,
            prezzo: v.p, listino: v.c,
            priceHtml: ui.prezzoCell(v.p, v.c, v.op),
            qtyHtml: v.m === 0
              ? ((window.OKKO.bisBottone && window.OKKO.bisBottone(v.id)) || '<div></div>')
              : ui.stepperHtml({ qtyAttr: 'okko-wl-qty', stepAttr: 'okko-wl-step', id: v.id, value: inBozza, max: v.m, min: 0, conf: v.cf }),
            subHtml: ui.subCell(v.m === 0 || inBozza === 0 ? '—' : inBozza * v.p, 'okko-wl-sub', v.id),
          });
        }).join('');
        const pillola = `<button type="button" class="okko-parent__count okko-wl-pill" data-okko-wl-expand aria-expanded="false">${CHEVRON_SVG}${vs.length} ${T.colori || 'colori'}</button>`;
        // prezzo/ricarico/P.cons UNITARI come la riga genitore del catalogo
        // (prezzo minimo tra le varianti, gia' scontato BSS; listino di prodotto).
        // L'unico aggregato e' il SUBTOT delle selezionate (aggiornaGruppi).
        const vMin = vs.reduce((a, b) => (b && b.p < a.p ? b : a), vs[0]);
        const listino = (vs.find((x) => typeof x.c === 'number' && x.c > 0) || {}).c || null;
        const rigaProdotto = ui.modalRow({
          leadHtml: frecce,
          img: en.i,
          url: en.u,
          title: en.t || 'Articolo',
          metaHtml: pillola,
          prezzo: vMin.p, listino,
          priceHtml: ui.prezzoCell(vMin.p, listino, vMin.op),
          // conteggio pezzi selezionati ("N pz", come la riga della collection)
          qtyHtml: '<span data-okko-wl-gqta>—</span>',
          subHtml: ui.subCell('—', 'okko-wl-gsub', id),
          actionsHtml: `<div class="okko-qo-row__azioni">${rimuovi}</div>`,
        });
        return `<div data-okko-wl-row="${id}">${rigaProdotto}<div class="okko-wl-kids" data-okko-wl-kids hidden>${kids}</div></div>`;
      }
      // La quantita' scrive DIRETTAMENTE nella bozza (stesso contratto del
      // catalogo e di "I tuoi piu' ordinati"): niente bottone Aggiungi per riga.
      const inBozza = draftQty(id);
      return ui.modalRow({
        attrs: `data-okko-wl-row="${id}"`,
        // maniglia drag (desktop) + frecce sposta su/giu' (mobile: il drag HTML5
        // non esiste sui touch) — visibilita' decisa dal CSS
        leadHtml: `<span class="okko-drag" data-okko-wl-drag data-okko-tip="${T.trascinaRiordina || 'Trascina per riordinare'}" title="${T.trascinaRiordina || 'Trascina per riordinare'}">${DRAG_SVG}</span>`
          + `<button type="button" class="okko-wl-freccia" data-okko-wl-sposta="-1" aria-label="Sposta su"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 10L8 5.5 12.5 10"/></svg></button>`
          + `<button type="button" class="okko-wl-freccia" data-okko-wl-sposta="1" aria-label="Sposta giu'"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 6L8 10.5 12.5 6"/></svg></button>`,
        img: en.i,
        url: en.u,
        title: en.t || 'Articolo',
        variante: en.v,
        sku: en.s,
        stock: en.m,
        pre: en.pre || 0,
        prezzo: en.p, listino: en.c,
        priceHtml: ui.prezzoCell(en.p, en.c, en.op),
        qtyHtml: en.m === 0
          ? ((window.OKKO.bisBottone && window.OKKO.bisBottone(id)) || '<div></div>')
          : ui.stepperHtml({ qtyAttr: 'okko-wl-qty', stepAttr: 'okko-wl-step', id, value: inBozza, max: en.m, min: 0, conf: en.cf }),
        subHtml: ui.subCell(en.m === 0 || inBozza === 0 ? '\u2014' : inBozza * en.p, 'okko-wl-sub', id),
        actionsHtml: `<div class="okko-qo-row__azioni">${rimuovi}</div>`,
      });
    }).join('');

    d.innerHTML = `
      <div class="okko-draft-modal__head">
        <h2 class="okko-draft-modal__title">${(window.OKKO.testi || {}).salvati || 'Salvati'} <small>${entries.length} ${entries.length === 1 ? ((window.OKKO.testi || {}).articolo || 'articolo') : ((window.OKKO.testi || {}).articoli || 'articoli')} \u00b7 ${(window.OKKO.testi || {}).suDispositivo || 'su questo dispositivo'}</small></h2>
        <button type="button" class="okko-draft-modal__close" data-okko-wl-close aria-label="Chiudi"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M4.5 4.5l7 7M11.5 4.5l-7 7"/></svg></button>
      </div>
      <div class="okko-draft-modal__body">${rows}</div>
      <div class="okko-draft-modal__foot">
        <button type="button" class="okko-btn okko-btn--ghost" data-okko-wl-close>${(window.OKKO.testi || {}).chiudi || 'Chiudi'}</button>
      </div>`;
    aggiornaGruppi();
    if (window.OKKO.paintBis) window.OKKO.paintBis(); // stato "gia' chiesto" sui bottoni delle righe esaurite
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-okko-wishlist-open]')) {
      const w = load();
      if (!Object.keys(w).length) return;
      render();
      ensureDialog().showModal();
      return;
    }
    if (!dialog || !dialog.open) return;

    // GRUPPO: TUTTA la riga prodotto apre/chiude le varianti, come in catalogo
    // (la pillola "N colori" ci ricade dentro). Il selettore figlio-diretto
    // prende solo la riga del genitore: le voci singole hanno l'attributo
    // sulla riga stessa, le sotto-righe stanno un livello piu' giu' nei kids.
    const rigaGruppo = e.target.closest('[data-okko-wl-row] > .okko-qo-row');
    if (rigaGruppo && !e.target.closest('a, input, [data-okko-wl-drag], [data-okko-wl-sposta], [data-okko-wl-remove]')) {
      const gruppo = rigaGruppo.parentElement;
      const kids = gruppo.querySelector('[data-okko-wl-kids]');
      if (kids) {
        kids.hidden = !kids.hidden;
        gruppo.querySelector('[data-okko-wl-expand]')?.setAttribute('aria-expanded', String(!kids.hidden));
        return;
      }
    }

    const step = e.target.closest('[data-okko-wl-step]');
    if (step) {
      const input = step.parentElement.querySelector('[data-okko-wl-qty]');
      const conf = Number(input.dataset.okkoConfezione) || 0;
      const inc = conf || (window.OKKO.passo ? window.OKKO.passo() : 1); // confezione: avanza di N
      input.value = String((Number(input.value) || 0) + Number(step.dataset.okkoWlStep) * inc);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true })); // riaggancia se si partiva da un non-multiplo
      return;
    }
    const remove = e.target.closest('[data-okko-wl-remove]');
    if (remove) {
      const w = load();
      delete w[remove.dataset.okkoWlRemove];
      save(w);
      render();
      paint();
      return;
    }
  });

  // --- Riordino per trascinamento -------------------------------------------
  // draggable si accende solo premendo la MANIGLIA: cosi' il resto della riga
  // (stepper, link, cestino) resta selezionabile e cliccabile come prima.
  let rigaTrascinata = null;

  document.addEventListener('pointerdown', (e) => {
    const maniglia = e.target.closest('[data-okko-wl-drag]');
    if (!maniglia) return;
    maniglia.closest('[data-okko-wl-row]')?.setAttribute('draggable', 'true');
  });

  // Frecce sposta su/giu' (mobile): scambio nel DOM + salvataggio ordine,
  // stesso percorso del drag (salvaOrdineDalDom legge l'ordine delle righe).
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-okko-wl-sposta]');
    if (!btn) return;
    const riga = btn.closest('[data-okko-wl-row]');
    if (!riga) return;
    const dir = Number(btn.dataset.okkoWlSposta);
    const vicina = dir < 0 ? riga.previousElementSibling : riga.nextElementSibling;
    if (!vicina || !vicina.hasAttribute('data-okko-wl-row')) return;
    if (dir < 0) riga.parentElement.insertBefore(riga, vicina);
    else riga.parentElement.insertBefore(vicina, riga);
    salvaOrdineDalDom();
  });

  document.addEventListener('dragstart', (e) => {
    const riga = e.target.closest('[data-okko-wl-row]');
    if (!riga) return;
    rigaTrascinata = riga;
    riga.classList.add('is-trascinata');
    e.dataTransfer.effectAllowed = 'move';
    // Firefox non avvia il drag senza dati nel dataTransfer
    e.dataTransfer.setData('text/plain', riga.dataset.okkoWlRow);
  });

  document.addEventListener('dragover', (e) => {
    if (!rigaTrascinata) return;
    // Accettare il rilascio SEMPRE dentro la lista, anche sopra la riga
    // trascinata stessa: se all'ultimo dragover il drop risulta rifiutato, il
    // browser suona l'animazione di ritorno all'origine prima di lasciare la
    // riga dove l'abbiamo messa noi.
    if (!e.target.closest('.okko-draft-modal__body')) return;
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';

    const sopra = e.target.closest('[data-okko-wl-row]');
    if (!sopra || sopra === rigaTrascinata) return;
    const r = sopra.getBoundingClientRect();
    const primaMeta = e.clientY < r.top + r.height / 2;
    sopra.parentNode.insertBefore(rigaTrascinata, primaMeta ? sopra : sopra.nextSibling);
  });

  document.addEventListener('drop', (e) => {
    if (!rigaTrascinata) return;
    e.preventDefault();
    e.stopPropagation();
  });

  document.addEventListener('dragend', () => {
    if (!rigaTrascinata) return;
    rigaTrascinata.classList.remove('is-trascinata');
    rigaTrascinata.removeAttribute('draggable');
    rigaTrascinata = null;
    salvaOrdineDalDom();
  });

  /**
   * SUBTOT del GRUPPO dalle quantita' in bozza, sulla riga del genitore.
   * Prezzo/ricarico/P.cons sul genitore restano UNITARI (come la riga della
   * collection, scelta di Nicolas): l'unico aggregato e' il subtotale.
   */
  function aggiornaGruppi() {
    if (!dialog) return;
    const w = load();
    dialog.querySelectorAll('[data-okko-wl-row]').forEach((gruppo) => {
      const en = w[gruppo.dataset.okkoWlRow];
      if (!en || !en.g) return;
      let sub = 0;
      let pezzi = 0;
      (en.vs || []).forEach((v) => {
        const q = window.OKKO.draftEntry ? (window.OKKO.draftEntry(v.id)?.q || 0) : 0;
        if (q > 0) { sub += q * v.p; pezzi += q; }
      });
      const subCella = gruppo.querySelector(':scope > .okko-qo-row [data-okko-wl-gsub]');
      if (subCella) subCella.textContent = sub > 0 ? money(sub) : '—';
      const qtaCella = gruppo.querySelector(':scope > .okko-qo-row [data-okko-wl-gqta]');
      const T = (window.OKKO && window.OKKO.testi) || {};
      if (qtaCella) qtaCella.textContent = pezzi > 0 ? `${pezzi} ${T.pz || 'pz'}` : '—';
    });
  }

  /** Entry-variante per id: voce singola in cima, oppure dentro `vs` di un gruppo. */
  function wlVariante(w, id) {
    const top = w[id];
    if (top && !top.g) return top;
    for (const k of Object.keys(w)) {
      const en = w[k];
      if (en && en.g && en.vs) {
        const v = en.vs.find((x) => String(x.id) === String(id));
        if (v) return v;
      }
    }
    return null;
  }

  // Scrive quantita' e riga della wishlist nella bozza. snap: aggancio alla confezione
  // (stepper/blur); durante la digitazione resta il solo tetto stock, come nel catalogo.
  function wlWriteQty(id, wanted, snap) {
    const w = load();
    const en = wlVariante(w, id);
    if (!en) return null;
    const q = window.OKKO.clampQty(wanted, en.m, snap ? (en.cf || 0) : 0);
    // la quantita' vive nella BOZZA (q=0 toglie la riga); i Salvati restano
    // una lista: l'articolo non sparisce da qui quando la quantita' torna a 0
    window.OKKO.draftWrite([{ id: Number(id), q, p: en.p, c: en.c, op: en.op, m: en.m, cf: en.cf || 0, pre: en.pre || 0, t: en.t, v: en.v, s: en.s, i: en.i, u: en.u }], { allowZero: true });
    const sub = dialog && dialog.querySelector(`[data-okko-wl-sub="${id}"]`);
    if (sub) sub.textContent = q > 0 ? money(q * en.p) : '\u2014';
    aggiornaGruppi(); // la riga del genitore aggrega le varianti selezionate
    return q;
  }

  document.addEventListener('input', (e) => {
    if (!e.target.matches('[data-okko-wl-qty]')) return;
    const q = wlWriteQty(e.target.dataset.okkoWlQty, e.target.value, false);
    if (q !== null) e.target.value = String(q);
  });

  // Fine digitazione (blur/Invio o change rilanciato dallo stepper): snap al multiplo.
  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-okko-wl-qty]')) return;
    const q = wlWriteQty(e.target.dataset.okkoWlQty, e.target.value, true);
    if (q !== null) e.target.value = String(q);
  });

  window.OKKO = window.OKKO || {};
  window.OKKO.paintWishlist = paint;

  document.addEventListener('DOMContentLoaded', paint);
  window.addEventListener('pageshow', (e) => { if (e.persisted) paint(); });
  // il ponte sconta le righe async: ri-riallinea le entry salvate col prezzo definitivo
  document.addEventListener('okko:bss:pronto', paint);
})();
